import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=4d3550aa&scoped=true&"
import script from "./FileInfo.vue?vue&type=script&lang=ts&"
export * from "./FileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FileInfo.vue?vue&type=style&index=0&id=4d3550aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3550aa",
  null
  
)

export default component.exports